import Vue from 'vue'
import Main from './main.vue'
import API from '@/api'
import store from '@/store'
import { LEAVE_ROLE } from '@/utils/constUtils'
import { getItem, getCombineRole } from '@/utils/comUtils'

const MConstructor = Vue.extend(Main) // 直接将Vue组件作为Vue.extend的参数
const cacheUserRange = {}
let MInstance = null
/**
 * 登录窗口
 * @param {object} options 配置
 */
const MSchoolAddressBook = async options => {
  return new Promise(async (resolve, reject) => {
    if (typeof options !== 'object') {
      reject(new Error('参数错误'))
      return
    }
    let _options = {
      addressType: options.addressType, // 1: 请假 2: 考勤 3: 其它
      role: options.role || LEAVE_ROLE.classTeacher, // 100 老师组，1 家长，7 学生
      userId: options.userId, // 钉钉用户ID
      corpName: options.corpName || '', // 钉钉机构名
      corpId: options.corpId || '', // 钉钉机构Id
      appId: options.appId || '', // 微应用Id
      campus: options.campus || {}, // 初始校区列表(角色为管理员时有效)
      classList: options.classList || [], // 初始班级列表(角色为班主任时必传)
      studentList: options.studentList || [], // 初始学生列表(角色为家长时必传)
      multiple: options.multiple === undefined ? true : options.multiple, // 是否多选  true：多选  false  单选
      selectType: options.selectType || 0, // 选择类型 0 所有层级都可以选 自定义校区（4-部门 3-班级 5-学生）
      endType: options.endType || options.selectType || 0,
      returnType: options.returnType || 0, // 返回值类型
      defaultSelectedDepts: options.defaultSelectedDepts || [], // 默认选中部门节点列表（注意：类型必须和returnType设定一致）
      defaultSelectedMembers: options.defaultSelectedMembers || [], // 默认选中部门节点列表（注意：类型必须和returnType设定一致）
      disabledDeptIds: options.disabledDeptIds || [], // 不可选中部门节点Id列表（注意：returnType为none和node时，必须传魔点部门Id，为ding和dingNode时，必须传钉钉Id）
      disabledMemberIds: options.disabledMemberIds || [], // 不可选中部门节点Id列表（注意：returnType为none和node时，必须传魔点部门Id，为ding和dingNode时，必须传钉钉Id）
      attendanceGroupId: options.attendanceGroupId || null,
      needReturn: options.needReturn || false, // 返回是否返回tag
      isShowTag: options.isShowTag || false, // 是否显示标签
      sandboxId: options.sandboxId, // 沙盒
      title: options.title, // 要展示的弹框的title
      liveInOnly: options.liveInOnly || false,
      isClassTeacher: options.isClassTeacher,
      classTeacherCampus: options.classTeacherCampus,
      classCampusAll: options.classCampusAll,
      doubleBack: options.doubleBack || false, // 双层回退
      isDentention: options.isDentention || false,
      limitMultiple:
        typeof options.limitMultiple === 'boolean'
          ? options.limitMultiple
          : true, // 是否需要对多选进行限制
      maxMember: options.multiple ? options.maxMember || 1500 : 1, // 最大可选人员
      forceSelection: options.forceSelection || false, // 强制重新勾选已选（兼容）
      isFlexLeave: options.isFlexLeave || false, // 是否滞留生
      cacheDeptCallback: options.cacheDeptCallback,
      appointRole: options.appointRole || 0, // 指定使用某角色。如果不存在或者未匹配，会使用默认的角色列表
      rangeList: [], // 要根据该角色范围进行展示。此字段与本地缓存的角色列表有强关联。为自定义角色时，需要此字段
      disabledCustomRole: options.disabledCustomRole || false, // 是否禁用自定义角色
      disabledTeacher: options.disabledTeacher || false, // 是否禁用任课老师角色 目前用于搜索接口
      isAttendanceFilter: options.isAttendanceFilter,
      selectedDeptIds: options.selectedDeptIds || [], // 选中的部门id
      selectedUserIds: options.selectedUserIds || [], // 选中的部门id
      isQingtian: options.isQingtian || false, // 是否青田机构
      viewDetailFlag: options.viewDetailFlag || false, // 是否查看已选择 目前支持学生
      canViewDetail:
        typeof options.canViewDetail === 'boolean'
          ? options.canViewDetail
          : true // 是否可点击已选择
    }

    // 自定义角色兼容处理
    await setGroupRangeList(_options)

    // 自定义校区 只能指定到人或者班级  经典校区可以指定到某个具体的层级
    if (
      Object.prototype.toString.call(options.campus) !== '[object Array]' &&
      options.campus &&
      options.selectType !== 5 &&
      options.selectType !== 0
    ) {
      _options.selectType = _options.selectType === 3 ? 3 : 5
    }
    // eslint-disable-next-line
    _options.close = function (result) {
      MSchoolAddressBook.close()
        .then(() => {
          resolve(result)
        })
        .catch(err => {
          reject(err)
        })
    }
    // eslint-disable-next-line
    _options.closeOnly = function () {
      MSchoolAddressBook.close()
        .then(res => {
          resolve({
            $type: this.needReturn ? 'onlyReturn' : ''
          })
        })
        .catch(err => {
          reject(err)
        })
    }
    MInstance = new MConstructor({
      data: _options
    })
    MInstance.vm = MInstance.$mount() // 挂载但是并未插入dom，是一个完整的Vue实例
    MInstance.dom = MInstance.vm.$el
    document.body.appendChild(MInstance.dom) // 将dom插入body
    MInstance.vm.visible = true
  })
}

// eslint-disable-next-line
MSchoolAddressBook.close = function () {
  return new Promise((resolve, reject) => {
    if (MInstance) {
      // //销毁vm实例与DOM之间的关联
      MInstance.vm.$destroy()
      window.history.go(-1)
      // 防止返回后通讯录一直盖在界面上没有消失
      let $addressDom = MInstance.dom
      $addressDom && $addressDom.remove()
      MInstance = null
    } else {
      let $addressDom = document.getElementById('$address-book$')
      $addressDom && $addressDom.remove()
    }
    resolve()
  })
}

const getUserRange = roleList => {
  return new Promise((resolve, reject) => {
    API.getRoleGroupUserRange({
      campusId:
        getItem('currentCapmusId') ||
        (store.getters.currentCapmus || {}).tpId ||
        '',
      operUserDingId: store.getters.token.userid || '',
      operUserRoleTypes: String(roleList)
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 获取权限范围并修改角色
const setGroupRangeList = async _options => {
  let { role, appointRole, isAttendanceFilter } = _options
  if (role !== LEAVE_ROLE.classTeacher) return
  let _roleList = getCombineRole(role, 'addressList')

  // 判断是否指定了角色
  if (appointRole) {
    let _appointRoleList = _roleList.filter(v => v === appointRole)
    if (_appointRoleList.length) {
      _roleList = _appointRoleList
    }
  }

  let { token } = store.getters

  // 管理员全校范围
  if (_roleList.includes(LEAVE_ROLE.admin)) {
    _options.role = LEAVE_ROLE.admin
    _options.groupRangeList = []
    return
  }

  // 存在自定义角色获取范围
  if (
    !_options.disabledCustomRole &&
    _roleList.includes(LEAVE_ROLE.customRole)
  ) {
    _options.role = LEAVE_ROLE.customRole
    let key = `${LEAVE_ROLE.customRole}_${token.userid}`
    if (!cacheUserRange[key]) {
      try {
        const res = await getUserRange(isAttendanceFilter ? 99 : _roleList)
        let rangeList = []
        let originRangeList = []
        if (!res.filter(item => item.deptType === 0).length) {
          originRangeList = res
          res.map(v => {
            let pathId = v.parentDingIds.split(',')
            pathId.push(v.deptDingId)
            rangeList.push({
              pathId
            })
          })
        }
        cacheUserRange[key] = rangeList
        cacheUserRange[key + '_origin'] = originRangeList
      } catch (error) {
        console.log(`/AddressList/src/main.js`, error)
      }
    }
    _options.rangeList = cacheUserRange[key] || []
    _options.originRangeList = cacheUserRange[key + '_origin'] || []
    return
  }

  // 仅仅是班主任或者老师
  if (
    _roleList.includes(LEAVE_ROLE.headmaster) ||
    _roleList.includes(LEAVE_ROLE.teacher)
  ) {
    _options.role = _roleList.includes(LEAVE_ROLE.headmaster)
      ? LEAVE_ROLE.headmaster
      : LEAVE_ROLE.teacher
  }
}
export default MSchoolAddressBook
